var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.855 14.358l.619.785-.619-.785zM12 12a1 1 0 102 0h-2zm3 5a1 1 0 102 0h-2zm12-1c0 6.075-4.925 11-11 11v2c7.18 0 13-5.82 13-13h-2zM16 27C9.925 27 5 22.075 5 16H3c0 7.18 5.82 13 13 13v-2zM5 16C5 9.925 9.925 5 16 5V3C8.82 3 3 8.82 3 16h2zM16 5c6.075 0 11 4.925 11 11h2c0-7.18-5.82-13-13-13v2zm-.25 16a.25.25 0 01.25-.25v2A1.75 1.75 0 0017.75 21h-2zm.25-.25a.25.25 0 01.25.25h-2c0 .966.784 1.75 1.75 1.75v-2zm.25.25a.25.25 0 01-.25.25v-2A1.75 1.75 0 0014.25 21h2zm-.25.25a.25.25 0 01-.25-.25h2A1.75 1.75 0 0016 19.25v2zM18 12c0 .637-.297 1.204-.764 1.572l1.238 1.571A3.995 3.995 0 0020 12h-2zm-4 0a2 2 0 012-2V8a4 4 0 00-4 4h2zm2-2a2 2 0 012 2h2a4 4 0 00-4-4v2zm1.236 3.572c-.436.344-.978.787-1.41 1.318C15.39 15.427 15 16.133 15 17h2c0-.238.104-.51.378-.848.28-.343.664-.669 1.096-1.009l-1.238-1.57z",
    fill: "#000"
  })));
}

export default SvgQuestion;